import React from 'react'
import styles from './LoadingSpinner.scss'

export default function LoadingSpinner(): JSX.Element {
  return (
    <div className={styles['c-loading-spinner']} data-test="spinner-wrapper">
      <div className={styles['c-loading-spinner__spinner']} data-test="spinner" />
    </div>
  )
}
